// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2JQdn","content":"LayoutSettings_content__2zWOA"};